export interface InputState {
  ax: number;
  ay: number;
  dash: boolean;
  strike: boolean;
  interact: boolean;
  lantern: boolean;
  pause: boolean;
  confirm: boolean;
}

export function createInput(target: HTMLElement): {
  sample: () => InputState;
  dispose: () => void;
} {
  const down = new Set<string>();
  const edge = new Set<string>();

  const onKey = (e: KeyboardEvent, press: boolean) => {
    const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " ", "Tab"].includes(e.key)) {
      e.preventDefault();
    }
    if (press) {
      if (!down.has(k)) edge.add(k);
      down.add(k);
    } else {
      down.delete(k);
    }
  };

  const kd = (e: KeyboardEvent) => onKey(e, true);
  const ku = (e: KeyboardEvent) => onKey(e, false);
  const blur = () => down.clear();

  window.addEventListener("keydown", kd);
  window.addEventListener("keyup", ku);
  window.addEventListener("blur", blur);
  target.addEventListener("contextmenu", (e) => e.preventDefault());

  let mouse = false;
  target.addEventListener("mousedown", (e) => {
    if (e.button === 0) {
      if (!mouse) edge.add("Mouse0");
      mouse = true;
    }
  });
  window.addEventListener("mouseup", (e) => {
    if (e.button === 0) mouse = false;
  });

  const held = (...keys: string[]) => keys.some((k) => down.has(k));
  const pressed = (...keys: string[]) => keys.some((k) => edge.has(k));

  return {
    sample() {
      let ax = 0;
      let ay = 0;
      if (held("a", "A", "ArrowLeft")) ax -= 1;
      if (held("d", "D", "ArrowRight")) ax += 1;
      if (held("w", "W", "ArrowUp")) ay -= 1;
      if (held("s", "S", "ArrowDown")) ay += 1;
      const st: InputState = {
        ax,
        ay,
        dash: pressed("Shift"),
        strike: pressed("j", "J", "Mouse0") || mouse && edge.has("Mouse0"),
        interact: pressed("e", "E", "Enter"),
        lantern: pressed("f", "F"),
        pause: pressed("Escape"),
        confirm: pressed("Enter", " "),
      };
      edge.clear();
      return st;
    },
    dispose() {
      window.removeEventListener("keydown", kd);
      window.removeEventListener("keyup", ku);
      window.removeEventListener("blur", blur);
    },
  };
}
